import React, { ReactNode } from "react";
import { AssignmentOutlined, GavelOutlined, HomeOutlined, InfoOutlined, Public, Settings, SettingsOutlined, SpeedOutlined, TableBar } from "@mui/icons-material";

import { MenuRoute } from "./toolympus/components/frame";
import { SystemSubmenu } from "./toolympus/components/Contests/SystemSubmenu";
import { EditDashboardsPage, DashboardsPage } from "./components/Administration/DashboardsPage";
import { Documentation } from "./components/Administration/Documentation";
import { AllDictionariesPage } from "./components/Administration/AllDictionariesPage";
import { CaseRecordForm, InternationalCaseRecordsList, NationalCaseRecordsList } from "./components/CaseRecords";
import { HomePage } from "./components/Administration/HomePage";
import { BiodevCmsEditor } from "./components/Administration/BiodevEditor";
import { InstrumentForm, InstrumentsList } from "./components/Instruments";
import { ConfigurableFormsRoutes } from "./toolympus/components/ConfigurableForms";
import { SettingsPage } from "./components/Administration/Settings";
import { CopDecisionForm, CopDecisionsList } from "./components/CopDecisions";
import { CopConferencesPage, CopTreePage } from "./components/CopDecisions/Tree";

export const LanguagesWithLabels: [string, ReactNode][] = [
  ["en", "en"],
]

const InnerRoutes: MenuRoute[] = [
  { path: '/dashboards', title: 'Дэшборды', component: EditDashboardsPage, hidden: true },

  { 
    path: '/home',
    title: 'Home',
    component: HomePage,
    icon: <HomeOutlined />,
  },



  {
    hidden: true,
    path: "/case/:id",
    title: "Cases",
    component: CaseRecordForm,
  },
  
  {
    hidden: true,
    path: "/case-national/:id",
    title: "Cases",
    component: CaseRecordForm,
  },
  {
    path: "/case",
    title: "International Cases",
    component: InternationalCaseRecordsList,
    icon: <AssignmentOutlined />,
    alsoActivateForPath: p => p.startsWith("/case/"),
  },
  {
    path: "/case-national",
    title: "National Cases",
    component: NationalCaseRecordsList,
    icon: <AssignmentOutlined />,
    alsoActivateForPath: p => p.startsWith("/case-national/"),
  },


  {
    hidden: true,
    path: "/instrument/:id",
    title: "Instruments",
    component: InstrumentForm,
  },
  {
    path: "/instrument",
    title: "Instruments",
    component: InstrumentsList,
    icon: <Public />,
    alsoActivateForPath: p => p.startsWith("/instrument/"),
  },

  {
    hidden: true,
    path: "/cop/tree/conferences",
    title: "COP Conferences",
    component: CopConferencesPage,
  },
  {
    hidden: true,
    path: "/cop/tree/tree",
    title: "COP Tree",
    component: CopTreePage,
  },

  {
    hidden: true,
    path: "/cop-decision/:id",
    title: "COP Decision",
    component: CopDecisionForm,
  },
  {
    path: "/cop-decision",
    title: "COP Decisions",
    component: CopDecisionsList,
    icon: <TableBar />,
    alsoActivateForPath: p => p.startsWith("/cop-decision/") || p.startsWith("/cop/"),
  },


  
  { 
    path: '/dictionaries',
    title: 'Dictionaries',
    icon: <GavelOutlined />,
    component: AllDictionariesPage,
  },

  { 
    path: '/system',
    title: 'System',
    icon: <Settings />,
    alsoActivateForPath: p => p.startsWith("/system/"),
    component: () => (
        <SystemSubmenu
            emails={{ apiPath: "/emails" }}
            users={{ allowCreateUsers: true, allowInvites: true, allowPaswordReset: true, allowPaswordChange: true, twoFactorAuthEnabled: true }}
            messages={{ apiPath: "/api/localization/messages" }}
            cms={{ apiPath: "/api/cms", includeMediaLib: true, EditorComponent: BiodevCmsEditor }}
            queryConsole={{}}
            apiTokens={{ apiPath: "/api/apitoken" }}
            robud={{}}
            extraItems={[
              {
                key: "forms",
                label: "Forms",
                icon: <AssignmentOutlined />,
                items: [{
                  key: "forms",
                  label: "Forms",
                  component: ConfigurableFormsRoutes,
                  componentProps: {
                    apiPath: "/api/form/config",
                    localization: {
                      defaultLocale: "en",
                      locales: LanguagesWithLabels,
                    }
                  }
                }],
              },
              {
                key: "settings",
                label: "Settings",
                icon: <SettingsOutlined />,
                items: [{ key: "settings", label: "", component: SettingsPage }]
              },
              {
                key: "documentation",
                label: "Documentation",
                icon: <InfoOutlined />,
                items: [{ key: "documentation", label: "", component: Documentation }]
              },
              {
                key: "dashboard",
                label: "Dashboards",
                icon: <SpeedOutlined />,
                items: [{ key: "dashboard", label: "", component: DashboardsPage }]
              },
            ]}
        />),
  },
];

export default InnerRoutes;